import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HostnameContainerModel } from '../../../../../models/aggregates/hostname';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { FilesDetailsRequest } from '../../../../../models/file-image';
import { FileDetails } from '../../../../../models/file-image/file-details';
import { ApiResponseModel, ApiVisa } from '..';

import { Observable } from 'rxjs';
import { Optional } from 'typescript-optional';
import { app_hostname_ext_RowClass } from '../../../../../models/dbschema/app_hostname_ext.model'
import { Pagination, PagingResponseModel } from './../shared';



@Injectable({
  providedIn: 'root'
})
export class HostnameService extends BaseApiTemplateService<HostnameContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'hostnames';
    this.httpClient = http;
  }


  getImageDetailsByGuid(imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + "/file/" + imageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/file/" + imageGuid;
    }
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  getFileByGuid(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + "/file/" + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/file/" + extGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  /** File Attachment related */
  public addImageAttachment(subjectGuid: string, formData: FormData, visa: ApiVisa, imageType: string) {
    let url = this.apiUrl + '/add-files/' + subjectGuid + '?hostnameSystemType=' + imageType;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + subjectGuid + '?hostnameSystemType=' + imageType;
    }
    return this.httpClient.post<ApiResponseModel<app_hostname_ext_RowClass>>(url, formData, this.getHttpHeader(visa));

  }

  /** Value string related */
  public addStringAttachment(subjectGuid: string, value: string, visa: ApiVisa, imageType: string) {
    let url = this.apiUrl + '/add-files/' + subjectGuid + '?hostnameSystemType=' + imageType;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + subjectGuid + '?hostnameSystemType=' + imageType;
    }
    return this.httpClient.post<ApiResponseModel<app_hostname_ext_RowClass>>(url, value, this.getHttpHeader(visa));

  }

  public editImageAttachment(subjectGuid: string, formData: FormData, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + subjectGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + subjectGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  deleteFile(extensionGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/file/' + extensionGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + extensionGuid;
    }
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  getAllHostname(visa: ApiVisa) {
    let url = this.apiUrl + '/sysadmin-ep';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep';
    }
    return this.httpClient.get<ApiResponseModel<HostnameContainerModel>>(url, this.getHttpHeader(visa));
  }

  getByCriteriaSysAdmin(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<HostnameContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<HostnameContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}
